import Box from 'components/elements/Box';
import formatNumber from 'helpers/formatNumber';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import { definitionLabel } from 'styles/base-classes';
import { numbersTypography } from 'styles/global/typography/typography';

const commonStyles = (): any => css`
  ${definitionLabel}
  font-size: 0.7em !important;
  letter-spacing: 1px !important;
  line-height: 1;
  font-weight: 600;
`;

const AccessLabel = styled('span')`
  ${commonStyles}
`;

const AccessValue = styled('span')<any>`
  ${commonStyles}
  color: ${({ theme }): string => theme.NightBlue};

  ${({ isSmallScreen, color }): any =>
    isSmallScreen &&
    color &&
    css`
        font-size: 16px !important;
        ${numbersTypography}
        color: ${color};
    `}
`;

const RowElement = styled(Box)<any>`
  line-height: 1;

  ${({ isSmallScreen }): any =>
    isSmallScreen &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}
`;

export const AccessDataValueWrapper = styled(Box)<{
  isSmallScreen: boolean | undefined;
}>`
  margin: ${({ isSmallScreen }): string =>
    isSmallScreen ? '0 0 0.25rem 1.5rem' : '0.5rem 0 0 0'};
`;

const AccessDataValue: React.FC<{
  data: any;
  isSmallScreen: boolean | undefined;
  onClick?: any;
}> = ({ data, isSmallScreen, onClick }) => {
  return (
    <AccessDataValueWrapper isSmallScreen={isSmallScreen} onClick={onClick}>
      {data &&
        data.map((element: any) => {
          return (
            <RowElement
              key={element.key}
              isSmallScreen={isSmallScreen}
              mb={isSmallScreen ? 1 : 0}
            >
              <AccessLabel>{element.label}</AccessLabel>{' '}
              <AccessValue
                color={element.dataColor}
                isSmallScreen={isSmallScreen}
              >
                {formatNumber(element.rawValue, 'full', false)}
              </AccessValue>
            </RowElement>
          );
        })}
    </AccessDataValueWrapper>
  );
};

export default AccessDataValue;
